export default "__VITE_ASSET__e7aa5830__"